import styled from '@emotion/styled'

import { spacing } from 'main/ui'

interface IProps {
  widthConstraint?: boolean
}

const FormSection = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  ${({ widthConstraint }) => (widthConstraint === false ? null : 'max-width: 450px')};

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`

export default FormSection
